import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined'
import CardValidationList from './CardValidationList'

const resource = {
  list: CardValidationList,
  icon: CreditScoreOutlinedIcon
}

export default resource
